/**
 * Return Store page base url including current brand
 * @param {string} url url address to look the base url
 * @param {string} page part of url unique to the page
 * @throws {Error} throws error if url or page parameters are not strings
 * @returns {string} page base url
 */
function baseUrl( url = window.location.href, page ) {
  if( typeof url === 'string' && typeof page === 'string' ) {
    return url.slice(0, url.indexOf(page) + page.length + 1)
  } else {
    throw Error(`Unexpected value for a baseUrl: url ${url} and page ${page}`)
  }

}

export default {
  baseUrl
}

export {
  baseUrl
}
